import type { ProviderCheckoutButtonClasses } from '@/components/checkout/provider-checkout-buttons';

function pricingBlockClass(className: string) {
  return `cms-block-pricing-pricing-1-pricing-1__${className}`;
}

export const pricingCheckoutButtonClasses = {
  buttonGroup: pricingBlockClass('providerButtonGroup'),
  checkoutError: pricingBlockClass('checkoutError'),
  providerButton: pricingBlockClass('providerButton'),
  providerButtonLabel: pricingBlockClass('providerButtonLabel'),
  providerStripeButton: pricingBlockClass('providerStripeButton'),
  providerStripeLabel: pricingBlockClass('providerStripeLabel'),
  providerStripeLogoWrap: pricingBlockClass('providerStripeLogoWrap'),
  providerLogoStripe: pricingBlockClass('providerLogoStripe'),
  providerStripeSecondaryButton: pricingBlockClass(
    'providerStripeSecondaryButton'
  ),
  providerPaypalButton: pricingBlockClass('providerPaypalButton'),
  providerPaypalSecondaryButton: pricingBlockClass(
    'providerPaypalSecondaryButton'
  ),
  providerPaypalLabel: pricingBlockClass('providerPaypalLabel'),
  providerPaypalLogoWrap: pricingBlockClass('providerPaypalLogoWrap'),
  providerLogoPaypal: pricingBlockClass('providerLogoPaypal'),
} satisfies ProviderCheckoutButtonClasses;
